import { z } from "zod";
import { zLocatie } from "@personeel/gen/hey-api/zod.gen";

export const LocatieSchema = zLocatie.strip();

export type LocatieModel = z.infer<typeof LocatieSchema>;
